"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spec = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const User = __importStar(require("../../../../user"));
const openapi_1 = require("../../../openapi");
const Dealer = __importStar(require("./schema"));
exports.NAMESPACE = 'Culligan.Api.V1.Admin.Dealer.Spec';
const Role = User.GlobalUserRole.enums;
const withDealerGuard = openapi_1.Security.v1Roles(Role.SystemAdmin, Role.Admin, Role.BrandManager, Role.Dealer);
const LocationListResponse = openapi_1.Response.Success(Dealer.LocationList).annotations({
    description: 'List of dealer locations',
});
const EmptySuccessResponse = openapi_1.Response.EmptyData.annotations({
    description: 'Successful dealer-location mutation',
});
const LocateDealerResponse = openapi_1.Response.Success(Dealer.LocateDealerResult).annotations({
    description: 'Dealer serving the installation address',
});
const listLocations = platform_1.HttpApiEndpoint.get('listLocations') `/location/list`
    .addSuccess(LocationListResponse)
    .annotate(platform_1.OpenApi.Title, 'List Dealer Locations')
    .annotate(platform_1.OpenApi.Description, 'Returns dealer locations. Users with the Dealer role only see locations whose id is in their dealerIds; other allowed roles see every location.')
    .pipe(withDealerGuard, openapi_1.Error.withV1StandardErrors);
const createLocation = platform_1.HttpApiEndpoint.post('createLocation') `/location`
    .setPayload(Dealer.CreateLocationPayload)
    .addSuccess(EmptySuccessResponse, { status: 201 })
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Create Dealer Location')
    .annotate(platform_1.OpenApi.Description, 'Creates a dealer location. Optional body fields are stored as null when omitted. region is always persisted as null.')
    .pipe(withDealerGuard, openapi_1.Error.withV1StandardErrors);
const updateLocation = platform_1.HttpApiEndpoint.put('updateLocation') `/location`
    .setPayload(Dealer.UpdateLocationPayload)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .addError(openapi_1.Error.V1NotFound)
    .annotate(platform_1.OpenApi.Title, 'Update Dealer Location')
    .annotate(platform_1.OpenApi.Description, 'Overwrites a dealer location. region is stored as null and createdAt is reset to the update time, so a seeded row loses its region. Returns 404 if no location exists for the given id and country. Success is 200.')
    .pipe(withDealerGuard, openapi_1.Error.withV1StandardErrors);
const deleteLocation = platform_1.HttpApiEndpoint.del('deleteLocation') `/location`
    .setPayload(Dealer.DeleteLocationPayload)
    .addSuccess(EmptySuccessResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Delete Dealer Location')
    .annotate(platform_1.OpenApi.Description, 'Deletes a dealer location by id in the JSON body. A missing location is not returned as 404; the handler answers 500 if delete throws. Success is 200.')
    .pipe(withDealerGuard, openapi_1.Error.withV1StandardErrors);
const locateDealer = platform_1.HttpApiEndpoint.post('locateDealer') `/geo/locate`
    .setPayload(Dealer.LocateDealerPayload)
    .addSuccess(LocateDealerResponse)
    .addError(openapi_1.Error.V1LegacyValidation)
    .annotate(platform_1.OpenApi.Title, 'Locate Dealer')
    .annotate(platform_1.OpenApi.Description, 'Looks up the dealer that serves an installation address by proxying the Culligan CPort LocateDealer SOAP API.')
    .pipe(withDealerGuard, openapi_1.Error.withV1StandardErrors);
exports.Spec = platform_1.HttpApiGroup.make('v1.admin.dealer')
    .add(listLocations)
    .add(createLocation)
    .add(updateLocation)
    .add(deleteLocation)
    .add(locateDealer)
    .prefix('/admin/dealer')
    .annotate(platform_1.OpenApi.Title, 'Dealer')
    .annotate(platform_1.OpenApi.Description, 'Admin dealer location and CPort geo-locate endpoints')
    .pipe(openapi_1.Audience.withAudiences(openapi_1.Audience.Audience.Admin));
//# sourceMappingURL=spec.js.map